/**
 * @generated SignedSource<<14f4a3d2577f293df52e89dce56e23ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDefaultSourceOfFundsViewerFragment$data = {
  readonly accountByUuid?: {
    readonly " $fragmentSpreads": FragmentRefs<"readCryptoAccountFragment">;
  } | null;
  readonly accountsV2: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly assetOrFiatCurrency: {
          readonly asset?: {
            readonly uuid: string;
          };
        } | null;
        readonly uuid: string;
        readonly " $fragmentSpreads": FragmentRefs<"readCryptoAccountFragment" | "readFiatWalletAccountFragment">;
      } | null;
    }>;
  } | null;
  readonly assetByUuid?: {
    readonly asset: {
      readonly latestPrice: {
        readonly price: string | null;
      } | null;
    };
  } | null;
  readonly cbPaySourcesOfFunds: ReadonlyArray<{
    readonly __typename: string;
    readonly account?: {
      readonly " $fragmentSpreads": FragmentRefs<"readCryptoAccountFragment" | "readFiatWalletAccountFragment">;
    } | null;
    readonly isEnabled?: boolean | null;
    readonly paymentMethod?: {
      readonly pickerData: {
        readonly expiresAt?: string | null;
      } | null;
      readonly uuid: string;
      readonly " $fragmentSpreads": FragmentRefs<"readFiatWalletPaymentMethodFragment" | "readPaymentMethodFragment">;
    } | null;
    readonly remainingAvailableLimit?: {
      readonly currency: string;
      readonly value: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"readPrimaryCryptoAccountFragment" | "readPrimaryFiatWalletFragment" | "readPrimaryPaymentMethodSoFFragment">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"readPrimaryCryptoAccountFromAccountsV2">;
  readonly " $fragmentType": "useDefaultSourceOfFundsViewerFragment";
};
export type useDefaultSourceOfFundsViewerFragment$key = {
  readonly " $data"?: useDefaultSourceOfFundsViewerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDefaultSourceOfFundsViewerFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useDefaultSourceOfFundsViewerFragment"
};

(node as any).hash = "f671ef0ab19b74d0a09962538e94c78d";

export default node;
